import { AppBar, Box, Button, CardMedia, IconButton, Menu, Toolbar } from '@mui/material';
import React from 'react';
import { NavLink } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../../../images/logo/logo.png';
import CloseIcon from '@mui/icons-material/Close';
import './Navigation.css';

const Navigation = () => {
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };

    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
        <>
            {/* Navigation For Mobile Device */}
            <Menu
                anchorEl={mobileMoreAnchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                className={mobileMenuId}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={isMobileMenuOpen}
                onClose={handleMobileMenuClose}
            >
                {/* Nav */}
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', pb: 2 }}>
                    {/* logo and close icon */}
                    <Box sx={{ mx: '25px', my: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <CardMedia
                            component="img"
                            sx={{ width: '120px' }}
                            image={logo}
                            alt="logo"
                        />
                        <CloseIcon onClick={handleMobileMenuClose} sx={{ cursor: 'pointer', color: '#433ED1' }} />
                    </Box>

                    {/* links */}
                    <NavLink to="/not_found" style={{ textDecoration: 'none', textAlign: 'left', fontSize: '18px', fontWeight: 500, fontFamily: 'poppins', color: '#383838', margin: '10px 0', padding: '0 25px' }}>About Us</NavLink>
                    <NavLink to="/works" style={{ textDecoration: 'none', textAlign: 'left', fontSize: '18px', fontWeight: 500, fontFamily: 'poppins', color: '#383838', margin: '10px 0', padding: '0 25px' }}>How it works</NavLink>
                    <NavLink to="/cases" style={{ textDecoration: 'none', textAlign: 'left', fontSize: '18px', fontWeight: 500, fontFamily: 'poppins', color: '#383838', margin: '10px 0', padding: '0 25px' }}>Use Cases</NavLink>
                    <NavLink to="/entreprise" style={{ textDecoration: 'none', textAlign: 'left', fontSize: '18px', fontWeight: 500, fontFamily: 'poppins', color: '#383838', margin: '10px 0', padding: '0 25px' }}>Entreprise Applications</NavLink>
                    <NavLink to="/team" style={{ textDecoration: 'none', textAlign: 'left', fontSize: '18px', fontWeight: 500, fontFamily: 'poppins', color: '#383838', margin: '10px 0', padding: '0 25px' }}>Team</NavLink>

                    {/* button */}
                    <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center', ml: '25px', mt: '10px' }}>
                        <Button sx={{ textDecoration: 'none', fontSize: '12px', lineHeight: '20px', color: "#FFFFFF", px: '22px', py: '7px', backgroundImage: 'linear-gradient(90deg, #312CC2 1.7%, #4D52E6 47.74%, #5868FE 100%)', fontWeight: 600, borderRadius: '1px' }} style={{ textTransform: 'capitalize' }}>
                            Buy QTNL
                        </Button>
                    </Box>
                </Box>
            </Menu>
        </>
    );
    return (
        <Box sx={{ flexGrow: 1, backgroundColor: '#ffffff', py: { xs: '5px', sm: '10px', md: '15px', lg: '20px' } }}>
            <AppBar sx={{ boxShadow: 0, px: 0 }} position="sticky" style={{ backgroundColor: '#ffffff' }}>
                <Toolbar sx={{ display: 'flex', alignItems: 'flex-center' }}>
                    {/* name */}
                    <NavLink to="/" >
                        <CardMedia
                            component="img"
                            sx={{ width: { xs: '170px', sm: '140px', md: '170px', lg: '228px', xl: '260px' } }}
                            image={logo}
                            alt="logo"
                        />
                    </NavLink>

                    {/* Right Nav */}
                    <Box sx={{ flexGrow: 1 }} />
                    <Box sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center' }}>
                        <NavLink to="/not_found" id="responsive-nav"
                            style={({ isActive }) => {
                                return {
                                    display: 'block',
                                    padding: '0 17px',
                                    textDecoration: 'none',
                                    fontSize: '18px',
                                    fontWeight: isActive ? 600 : 300,
                                    color: isActive ? '#433ED1' : '#383838',
                                    fontFamily: 'poppins',
                                    backgroundColor: '#FFFFFF'
                                };
                            }}>About Us</NavLink>
                        <NavLink to="/works" id="responsive-nav"
                            style={({ isActive }) => {
                                return {
                                    display: 'block',
                                    padding: '0 17px',
                                    textDecoration: 'none',
                                    fontSize: '18px',
                                    fontWeight: isActive ? 600 : 300,
                                    color: isActive ? '#433ED1' : '#383838',
                                    fontFamily: 'poppins',
                                    backgroundColor: '#FFFFFF'
                                };
                            }}>How it works</NavLink>
                        <NavLink to="/cases" id="responsive-nav"
                            style={({ isActive }) => {
                                return {
                                    display: 'block',
                                    padding: '0 17px',
                                    textDecoration: 'none',
                                    fontSize: '18px',
                                    fontWeight: isActive ? 600 : 300,
                                    color: isActive ? '#433ED1' : '#383838',
                                    fontFamily: 'poppins',
                                    backgroundColor: '#FFFFFF'
                                };
                            }}>Use Cases</NavLink>
                        <NavLink to="/entreprise" id="responsive-nav"
                            style={({ isActive }) => {
                                return {
                                    display: 'block',
                                    padding: '0 17px',
                                    textDecoration: 'none',
                                    fontSize: '18px',
                                    fontWeight: isActive ? 600 : 300,
                                    color: isActive ? '#433ED1' : '#383838',
                                    fontFamily: 'poppins',
                                    backgroundColor: '#FFFFFF'
                                };
                            }}>Entreprise Applications</NavLink>
                        <NavLink to="/team" id="responsive-nav"
                            style={({ isActive }) => {
                                return {
                                    display: 'block',
                                    padding: '0 17px',
                                    textDecoration: 'none',
                                    fontSize: '18px',
                                    fontWeight: isActive ? 600 : 300,
                                    color: isActive ? '#433ED1' : '#383838',
                                    fontFamily: 'poppins',
                                    backgroundColor: '#FFFFFF'
                                };
                            }}>Team</NavLink>
                        {/* button */}
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', ml: { sm: '7px', md: '10px', lg: '17px' } }}>
                            <Button sx={{ textDecoration: 'none', fontSize: { sm: '11px', md: '14px', lg: '16px' }, lineHeight: '20px', color: "#FFFFFF", px: { sm: '18px', md: '22px' }, py: { sm: '5px', md: '6px', lg: '7px' }, backgroundImage: 'linear-gradient(90deg, #312CC2 1.7%, #4D52E6 47.74%, #5868FE 100%)', fontWeight: 600, borderRadius: '1px' }} style={{ textTransform: 'capitalize' }}>
                                Buy QTNL
                            </Button>
                        </Box>
                    </Box>

                    {/* call for small device */}
                    <Box sx={{ display: { xs: 'flex', sm: 'none' } }}>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            onClick={handleMobileMenuOpen}
                        >
                            <MenuIcon sx={{ color: '#433ED1' }} />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>
            {renderMobileMenu}
        </Box >
    );
};

export default Navigation;